import { render, staticRenderFns } from "./EmployeeProfileCard.vue?vue&type=template&id=4b815b24&scoped=true&"
import script from "./EmployeeProfileCard.vue?vue&type=script&lang=js&"
export * from "./EmployeeProfileCard.vue?vue&type=script&lang=js&"
import style0 from "./EmployeeProfileCard.vue?vue&type=style&index=0&lang=css&"
import style1 from "./EmployeeProfileCard.vue?vue&type=style&index=1&id=4b815b24&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4b815b24",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VAutocomplete } from 'vuetify/lib/components/VAutocomplete';
import { VCard } from 'vuetify/lib/components/VCard';
import { VCol } from 'vuetify/lib/components/VGrid';
import { VImg } from 'vuetify/lib/components/VImg';
import { VRow } from 'vuetify/lib/components/VGrid';
installComponents(component, {VAutocomplete,VCard,VCol,VImg,VRow})
